/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { DefaultTooltipContent } from 'recharts/lib/component/DefaultTooltipContent';
//  import { LineChart,Line, XAxis, YAxis, CartesianGrid, Tooltip, Label, Legend, ResponsiveContainer } from 'recharts';
import {
    ComposedChart,
    Area,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,

} from "recharts";
import PropTypes from 'prop-types';
import moment from 'moment';
import { monthWithDays } from '../../helper';
import { setCurrencyFormat, colorsCombination, colorArray } from '../../../../utils/helpers';

export const CustomTooltip = (props) => {
    // eslint-disable-next-line react/prop-types
    const { active, payload } = props;
    // we don't need to check payload[0] as there's a better prop for this purpose
    if (!active) {
      // I think returning null works based on this: http://recharts.org/en-US/examples/CustomContentOfTooltip
      return null
    }
    // mutating props directly is against react's conventions
    // so we create a new payload with the name and value fields set to what we want
    // eslint-disable-next-line react/prop-types
  
    const newPayload = Object.values(payload).sort((a, b) => a.value < b.value ? 1 : -1).map((item) => {
        const updated = { ...item }
        updated.value = setCurrencyFormat(Number(item?.value).toFixed(0), false);
        return updated;
    })    
    // we render the default, but with our overridden payload
    return <DefaultTooltipContent {...props} payload={newPayload} />;
  };

const SessionByReffererChart = ({ dir, showTitle, companyBasedOn, index,
    dataToShow, height, category, allCategories }) => {
    const thisMonthData = {};
    const currentDataByYear = {};
    const getRandomColor = () => {
        const letters = '0123456789ABCDEF'.split('');
        let fillColor = '#';
        for (let i = 0; i < 6; i += 1) {
            fillColor += letters[Math.floor(Math.random() * 16)];
        }
        return fillColor;
    }   
    return (      
        <ResponsiveContainer height={height}>
        <ComposedChart
            data={dataToShow}
            margin={{
                top: 0, right: 0, left: 25, bottom: 0,
            }}
        >
            <CartesianGrid vertical={false} horizontal  stroke="#FF0000" strokeWidth={2} />
            <XAxis dataKey="currentMonthDataKey" reversed={dir === 'rtl'} />
            <YAxis orientation={dir === 'rtl' ? 'right' : 'left'}
                tickFormatter={item => setCurrencyFormat(item, false)}
                width={90}
                allowDataOverflow
            />
            <Tooltip content={<CustomTooltip
                allCategories={allCategories} isSalesKey="Amount" />}
            /> 
            <Legend />
            {/* <Area type="monotone" dataKey="Amount" fill="#87bdd8" stroke="#87bdd8" /> */}
            {allCategories && Object.keys(allCategories).map((categ, ind) => (
                <Bar key={categ}
                    stackId="a"
                    dataKey={categ.toString()}
                    barSize={40} fill={getRandomColor()} />
            ))}
        </ComposedChart>
    </ResponsiveContainer>    
    )
}

SessionByReffererChart.propTypes = {
    dir: PropTypes.string.isRequired,
    dataToShow: PropTypes.object.isRequired,
    height: PropTypes.number.isRequired,
    showTitle: PropTypes.bool,
    category: PropTypes.string.isRequired,
    companyBasedOn: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    allCategories: PropTypes.object.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
};

SessionByReffererChart.defaultProps = {
    showTitle: true
  }

export default React.memo(SessionByReffererChart);